import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import PropTypes from 'prop-types';
import { useProjects } from '../useProjects';
import { dataModel } from '../dataModel';
import { loadingStateCard, NoProjectsStateCard } from './EmptyStateCard';
import { FullStateCard } from './FullStateCard';
import { FullStateCarouselCard } from './FullStateCarouselCard';
import { useMatchMedia } from '../../hooks/useMatchMedia';
import { MOBILE_MEDIA, MOBILE_WIDTH, CARD_VIEW, TABLE_VIEW } from '../project-summary-helper';

export const ProjectsRecapCard = ({ isValidCustomer }) => {
  const matchMedia = useMatchMedia(MOBILE_MEDIA, MOBILE_WIDTH);
  const isMobileLayout = matchMedia?.matches ?? false;
  const view = isMobileLayout ? CARD_VIEW : TABLE_VIEW;
  const { projects, loading, error } = useProjects({ page: 1, view, isValidCustomer, sortCriteria: [] });

  return (
    <>
      {loading && !error && !projects?.length && loadingStateCard}
      {!loading && !error && !projects?.length && (
        <NoProjectsStateCard shouldShowBadge />
      )}
      {!loading && !!projects?.length && isMobileLayout ? (
        <FullStateCarouselCard
          loading={loading}
          projects={projects}
          shouldShowBadge
        />
      ) : (
        <FullStateCard
          loading={loading}
          projects={projects}
          shouldShowBadge
        />
      )}
    </>
  );
};

ProjectsRecapCard.displayName = 'ProjectsRecapCard';

ProjectsRecapCard.propTypes = {
  isValidCustomer: PropTypes.bool.isRequired,
};

ProjectsRecapCard.dataModel = extend(dataModel);
